module.exports = __webpack_public_path__ + "img/20190614161811515.026cadb1.png";